import { toast } from 'react-toastify';
import { GraphQLError } from 'graphql/error/GraphQLError';

const ERROR_UNIQUE_CONSTRAINT = 'Unique constraint failed on the fields: (`name`)'; // prettier-ignore

/**
 * @name maybeShowApiToastError
 * @description tbd...
 */
export function showApiToastError(error: GraphQLError, thing: string) {
  const uniqueError = error.message.includes(ERROR_UNIQUE_CONSTRAINT);
  if (uniqueError) {
    toast.error(
      `Not Saved! A ${thing} with that name already exists. Please use a unique name.`,
    );
  }
}
